export default __webpack_public_path__ + "static/media/451.722f23b6.svg";